export default function PackagesService($http, appSettings, $q, gettextCatalog) {
  'ngInject';
  return {
    getAllPackages: function() {
      return $http.get(appSettings.InReachApiPackagesEndpoint);
    },
    getPackageById: function(packageid) {
      return $http.get(appSettings.InReachApiPackagesEndpoint + '/' + packageid);
    },
    getPackageByIds: function(packageIds = []) {
      return $http.post(`${appSettings.InReachApiPackagesEndpoint}/filter`, packageIds);
    },
    getDatapointsForPackage: function(packageid) {
      return $http.get(appSettings.InReachApiPackagesEndpoint + '/' + packageid + '/_datapoints');
    },
    getDatapointsForPackages: function(packageIds) {
      let def = $q.defer();
      if (packageIds == null) {
        def.reject(gettextCatalog.getString('Must specify at least one package'));

        return def.promise;
      }

      let promises = [];

      for (let i = 0; i < packageIds.length; i++) {
        promises.push(this.getDatapointsForPackage(packageIds[i]));
      }

      let mainPromise = $q.all(promises);

      mainPromise.then(
        function(responseList) {
          let datapointSet = {};
          responseList.forEach(response => {
            response.data.forEach(datapoint => {
              datapointSet[datapoint] = true;
            });
          });

          let datapointList = [];
          for (let key in datapointSet) {
            datapointList.push(key);
          }

          def.resolve(datapointList);
        },
        function(response) {
          def.reject(response);
        }
      );

      return def.promise;
    }
  };
}
